























































































































































































import { Component, Vue } from "vue-property-decorator";
import UsersApi from "@/services/UsersApi";
import OrganizationUsersApi from "@/services/OrganizationUsers";
import MaterialGroupApi from "@/services/MaterialGroups";
import MaterialApi from "@/services/Materials";
import "github-markdown-css/github-markdown-light.css";
import highlight from "highlight.js";
import "highlight.js/styles/vs2015.css";
import { marked } from "marked";
import ImageModal from "@/components/ImageModal.vue";
import {
  Category,
  EnvelopedPaginatedUGCList,
  Material,
  MaterialGroup,
  MaterialGroupList,
  SortDirection,
} from "@/api/lab-base-api-client";
import UgcsApi from "@/services/Ugcs";
import AuthModule from "@/store/auth";
import { AxiosResponse } from "axios";
import fileDownload from "js-file-download";
import { BreadcrumbProps } from "@/types";
import logger from "@/lib/log/logger";

@Component({
  components: {
    ImageModal,
  },
})
export default class CMaterials extends Vue {
  // breadcrumbs設定配列
  private breadcrumbs: BreadcrumbProps[] = [];

  // hum-menu
  private ActiveBtn = false;

  // 完了ボタン
  private isCompBtn = false;

  // 完了したmaterial教材
  private compMaterials: string[] = [];

  // 所属カテゴリー
  private category: Category | null | undefined = null;

  // materialGroup一覧
  private materialGroup: MaterialGroup | null = null;

  // 次のmaterialGroup
  private nextMaterialGroup: MaterialGroupList | null = null;

  // material
  private material: Material | null = null;

  // 現在のセクションの前へ、次へ
  private next = { title: this.material?.title, uuid: this.material?.uuid };

  private prev = { title: this.material?.title, uuid: this.material?.uuid };

  // 次のmaterialGroupへ進むダイアログ
  private isNextMaterialGroupDialog = false;

  // 教材のlength
  private materialLength = 0;

  // モーダルの切り替え
  private showMaterialGroup = false;

  // imageモーダルのsrc
  private postItem: string | null = "";

  private ugcs: AxiosResponse<EnvelopedPaginatedUGCList> | undefined;

  // ugcの全データ取得
  private async getUgcs() {
    this.ugcs = await UgcsApi.instance.getUGCs();
  }

  // ユーザー以外、または有料ユーザーかつ有料コンテンツ、または無料コンテンツ、または非公開教材の場合
  private get isAllowAccess() {
    return (
      AuthModule.me?.role.id !== (2 || 4) ||
      (AuthModule.me?.paidFlag && this.materialGroup?.planId) ||
      !this.materialGroup?.planId ||
      this.materialGroup?.visibilityFlag
    );
  }

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  // ページ読み込み時に実行
  private async mounted() {
    await Promise.all([this.fetchMaterialGroup(), this.checkOrganizationExpiration()]);

    if (!this.isAllowAccess) {
      this.$router.push({ name: "UDashboard" });
      return;
    }

    await this.setMaterial(String(this.$route.query.material));

    if (this.$route.name === "UContent") {
      this.registerBookmark(String(this.$route.query.material));
      this.fetchCompMaterial();
    }
    // 処理が終わってからPromise.allの2つが同時に実行される
    await Promise.all([this.generateBreadcrumbs(), this.setAround(String(this.$route.query.material))]);
  }

  // organizationUser契約期限のチェック
  private async checkOrganizationExpiration() {
    if (!this.me || this.me.roleId !== 4) {
      return;
    }
    await OrganizationUsersApi.instance.checkExpirationDate(this.me.uuid);
  }

  // モーダルを開く
  private openModal(event: Event) {
    if (!event) {
      return;
    }
    this.showMaterialGroup = true;
    this.postItem = (event?.target as HTMLImageElement).src;
  }

  // モーダルを閉じる
  private closeModal() {
    this.showMaterialGroup = false;
  }

  // 前、次のsectionへ移動時にtopへ移動
  private gotoTop() {
    const selectedElement = document.getElementById("sectionContent");
    if (selectedElement) {
      // スクロール
      selectedElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }

  private async fetchMaterialGroup() {
    // materialGroup一覧（materialGroup）を取得
    const materialGroupsRes = await MaterialGroupApi.instance.getMaterialGroupByUuid(String(this.$route.query.uuid));
    const materialsRes = await MaterialApi.instance.getMaterialByRemoveDeleted(String(this.$route.query.uuid));

    this.materialGroup = materialGroupsRes.data.data?.materialGroup;
    if (materialsRes.data.data.material) {
      const materials = materialsRes.data.data.material.filter((material: { deleted: boolean }) => !material.deleted);
      // sort順に並び替え
      materials.sort((a, b) => {
        if (a.sort > b.sort) {
          return 1;
        }
        return -1;
      });
      this.materialGroup.materials = materials;
      this.materialLength = this.materialGroup.materials.length;
    }
  }

  // TODO: 取得方法変更
  private async fetchCompMaterial() {
    if (!this.me) {
      return;
    }
    const userDetailMaterials = await UsersApi.instance.getCompleteMaterialsByUserDetailUuid(this.me.userDetailUuid);
    this.compMaterials = userDetailMaterials.data.data.completeMaterial.items.map(
      (material: { materialUuid: string }) => {
        return material.materialUuid;
      }
    );
  }

  private generateBreadcrumbs() {
    if (!this.materialGroup) {
      return;
    }
    this.category = this.materialGroup.categories.find((cat: Category) => cat.slug === this.$route.params.category);
    if (!this.category) {
      return;
    }
    this.breadcrumbs = [
      {
        text: "category",
        disabled: false,
        to: { name: this.$route.name === "UContent" ? "UCategory" : "OCategory" },
        exact: true,
      },
      {
        text: this.$route.params.category,
        disabled: false,
        to: {
          name: this.$route.name === "UContent" ? "UContents" : "OContents",
          params: this.$route.params.category,
          query: { id: this.category.id },
        },
        exact: true,
      },
      {
        // text: this.$route.params.content,
        text: this.materialGroup.name,
        disabled: true,
      },
    ];
  }

  // materialGroupの取得
  private async setMaterial(uuid: string) {
    const MaterialRes = await MaterialApi.instance.getMaterialByUuid(String(uuid));
    if (MaterialRes.data.data.material) {
      this.material = MaterialRes.data.data.material;
    }
    marked.setOptions({
      highlight: (code, lang) => {
        return highlight.highlightAuto(code, [lang]).value;
      },
    });
    const renderer = new marked.Renderer();
    renderer.image = src => {
      return `<div class="material-img" value="${src}">
          <img src="${src}">
        </div>`;
    };
    renderer.link = (href, title, text) => {
      return `<a class="link" href=javascript:void(0) data-url="${href}">${text}</a>`;
    };
    if (this.material) {
      this.material.content = marked(this.material.content, { renderer });
    }
    // markdown -> HTMLに変換する際のclick eventをつける場所
    // this.$nextTick DOMが更新された後に処理を行う機能
    // https://johobase.com/vue-js-nexttick/
    this.$nextTick(() => {
      const imgElements = document.querySelectorAll(".material-img");
      if (imgElements.length > 0) {
        imgElements.forEach(elem => {
          elem.addEventListener("click", this.openModal);
        });
      }
      const linkElements = document.querySelectorAll(".link");
      if (linkElements.length > 0) {
        linkElements.forEach(elem => {
          elem.addEventListener("click", this.download);
        });
      }
    });
  }

  // 次へ、前へのparams,queryへ値をセット
  private setAround(uuid: string) {
    if (this.materialGroup && this.materialGroup.materials) {
      for (let i = 0; i < Object.keys(this.materialGroup.materials).length; i += 1) {
        if (uuid === this.materialGroup.materials[i].uuid) {
          if (i !== 0) {
            this.prev.title = this.materialGroup.materials[i - 1].title;
            this.prev.uuid = this.materialGroup.materials[i - 1].uuid;
          }

          if (i !== Object.keys(this.materialGroup.materials).length - 1) {
            this.next.title = this.materialGroup.materials[i + 1].title;
            this.next.uuid = this.materialGroup.materials[i + 1].uuid;
          }
        }
      }
    }
  }

  private async download(e: Event) {
    try {
      const element = e.target as HTMLInputElement;
      const fileUrl = element.dataset.url;

      // 取得したurlを元に一致するUGCを取得
      // eslint-disable-next-line no-unused-expressions,no-shadow
      const targetUgc = this.ugcs?.data.data?.items?.find(element => {
        return element.url === fileUrl;
      });

      // 一致したUGCが存在するならダウンロード、それ以外ならページ遷移
      if (targetUgc) {
        const ugcData = await UgcsApi.instance.getUGC(targetUgc.uuid);
        const ugcRes = await UgcsApi.instance.getDownloadUGC(targetUgc.uuid, { responseType: "blob" });
        fileDownload(ugcRes.data, ugcData.data.data.ugc.metadata.originalname);
      } else if (fileUrl) {
        window.location.href = fileUrl;
      }
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // コンテンツ完了ボタンをクリック
  private async clickMaterialGroupComp() {
    await this.submitCompMaterial(String(this.$route.query.material));
    await this.submitCompMaterials(String(this.$route.query.uuid));
    await this.fetchCompMaterial();

    await this.setNextMaterialGroup();
    this.isNextMaterialGroupDialog = true;
  }

  // 完了したコンテンツ教材登録
  private async submitCompMaterials(uuid: string) {
    try {
      if (this.me?.uuid) {
        await UsersApi.instance.postCompleteMaterialGroupByUuid(this.me.uuid, { completeMaterialGroupUuid: uuid });
      }
    } catch (error) {
      console.log(error);
    }
  }

  // セクション完了ボタンをクリック
  private async clickMaterialComp() {
    await this.submitCompMaterial(String(this.$route.query.material));
    await this.fetchCompMaterial();
    // 次のセクションへ
    if (!this.materialGroup) {
      return;
    }
    this.$router.push({
      name: "UContent",
      params: { content: this.materialGroup.name },
      query: { uuid: this.$route.query.uuid, material: this.next.uuid },
    });
  }

  // 完了したセクション教材登録
  private async submitCompMaterial(uuid: string) {
    try {
      if (this.me?.uuid) {
        await UsersApi.instance.postCompleteMaterialByUuid(this.me.uuid, { completeMaterialUuid: uuid });
      }
    } catch (error) {
      console.log(error);
    }
  }

  // スクロール位置を調べる
  private onScroll(event: Event) {
    this.$nextTick(() => {
      if (!(event.target instanceof HTMLElement)) {
        return;
      }

      const { clientHeight, scrollHeight } = event.target;
      // したまでスクロールした時、完了ボタンを表示
      this.isCompBtn = scrollHeight - (clientHeight + event.target.scrollTop) < 10;
    });
  }

  // ブックマークに登録
  private async registerBookmark(uuid: string) {
    if (!this.me) {
      return;
    }
    await UsersApi.instance.patchBookmarkByUuid(this.me.uuid, {
      bookmark: { uuid },
    });
  }

  // 次のmaterialGroupへ進む
  private async setNextMaterialGroup() {
    // MaterialGroup一覧取得
    const materialGroupsRes = await MaterialGroupApi.instance.getMaterialGroup(
      undefined,
      undefined,
      SortDirection.Asc,
      undefined,
      undefined,
      true
    );
    // カテゴリーが存在するMaterialGroup一覧に
    const allMaterialGroups = materialGroupsRes.data.data.items.filter(
      (materialGroup: { categories: {} }) => materialGroup.categories
    );

    const materialGroups: MaterialGroupList[] = [];
    // カテゴリーと一致し、かつmaterialを持つMaterialGroupを取り出す
    allMaterialGroups.forEach((materialGroup: MaterialGroupList) => {
      // カテゴリ-の数分回す
      for (let i = 0; i < materialGroup.categories.length; i += 1) {
        if (!materialGroup.materials) {
          return;
        }
        // カテゴリーidとqueryのidが同一かつmaterialsが一つ以上、かつ非公開教材じゃない場合
        if (
          materialGroup.categories[i].id === this.category?.id &&
          !materialGroup.visibilityFlag &&
          materialGroup.materials.length > 0
        ) {
          const materials = materialGroup.materials.filter((material: { deleted: boolean }) => !material.deleted);
          // eslint-disable-next-line no-param-reassign
          materialGroup.materials = materials;
          materialGroups.push(materialGroup);
        }
      }
    });

    const index = materialGroups.findIndex((materialGroup, i, array) => {
      return materialGroup.uuid === this.materialGroup?.uuid && i !== array.length - 1;
    });

    if (index !== -1) {
      this.nextMaterialGroup = materialGroups[index + 1];
    } else {
      this.nextMaterialGroup = null;
    }

    if (this.nextMaterialGroup) {
      this.nextMaterialGroup.materials.sort((a, b) => {
        if (a.sort > b.sort) {
          return 1;
        }
        return -1;
      });
    }
  }

  private clickNextMaterialGroupStart() {
    this.materialGroup = this.nextMaterialGroup;
    this.generateBreadcrumbs();
    this.isNextMaterialGroupDialog = false;
  }
}
